export default __webpack_public_path__ + "static/media/logoSogang.91cf5d46.jpg";